import { render, staticRenderFns } from "./ReportStatsCard.vue?vue&type=template&id=3795af9e&scoped=true&"
import script from "./ReportStatsCard.vue?vue&type=script&lang=js&"
export * from "./ReportStatsCard.vue?vue&type=script&lang=js&"
import style0 from "./ReportStatsCard.vue?vue&type=style&index=0&id=3795af9e&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3795af9e",
  null
  
)

export default component.exports